export default function fixColorContrast() {
    var backgroundColor = getComputedStyle(document.documentElement).getPropertyValue('--background-color');
    backgroundColor = backgroundColor.trim().slice(1);
    var red = parseInt(backgroundColor.substr(0, 2), 16);
    var green = parseInt(backgroundColor.substr(2, 2), 16);
    var blue = parseInt(backgroundColor.substr(4, 2), 16);
    var luminance = ((red * 299) + (green * 587) + (blue * 114)) / 1000;
    var textColorClass = (luminance >= 128) ? 'v-has-dark-text' : 'v-has-light-text';
  
    document.documentElement.classList.add(textColorClass);
  }